import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { FileUploadInputComponent } from '../../inputs/file-upload-input/file-upload-input.component';
import { FormErrorComponent } from '../../form-error/form-error.component';

@Component({
  selector: 'lib-file-upload-form-field',
  imports: [FileUploadInputComponent, ReactiveFormsModule, FormErrorComponent],
  templateUrl: './file-upload-form-field.component.html',
  styleUrl: './file-upload-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadFormFieldComponent {
  inputFormControl = input.required<FormControl<File[]>>();
  label = input<string>();
  multiple = input<boolean>(true);
  accept = input<string>('image/png, image/jpeg, application/pdf');
  description = input<string>($localize`Upload a file or drag and drop a .png, .jpeg or .pdf`);
  isSubmitted = input<boolean>(false);
  hintText = input<string | null | undefined>();
  showCropDialog = input<boolean>(false);
  readonly singleFileOnlyError = input<string | null>(null);
  inputId: string = uuidv4();
}
